import { Component } from '@angular/core';

@Component({
  selector: 'app-please-wait-dialog',
  templateUrl: './please-wait-dialog.component.html',
  styleUrls: ['./please-wait-dialog.component.scss']
})
export class PleaseWaitDialogComponent {

}
